import { render, staticRenderFns } from "./confirm-delete-contacts-modal.vue?vue&type=template&id=3664c850"
import script from "./confirm-delete-contacts-modal.vue?vue&type=script&lang=js"
export * from "./confirm-delete-contacts-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports